export default [
  {
    fileName: "client/vn-dejun3.png",
    link: "https://upromania.ro/companii/card-de-tichete-de-masa-up-dejun/",
    category: "Banner",
    action: "Click",
    label: "Client_vn_dejun_45",
  },
  {
    fileName: "client/banner_recommend_2.png",
    link: "https://upromania.ro/recomanda/?utm_source=uponline&utm_medium=banner&utm_campaign=Recomanda",
    category: "Banner",
    action: "Click",
    label: "Client_Recomanda",
  },
  // {
  //   fileName: "client/up-onlline-clienti.png",
  //   link:
  //     "https://upromania.ro/companii/card-cultural/",
  //   category: "Banner",
  //   action: "Click",
  //   label: "campanie_card_cultura",
  // },
];
